import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { DropboxLandingMobileModule } from './dropbox-landing-mobile/dropbox-landing-mobile.module';
import { DropboxPrepareMobileModule } from './dropbox-prepare-mobile/dropbox-prepare-mobile.module';
import { DropboxSendMobileModule } from './dropbox-send-mobile/dropbox-send-mobile.module';
import { DropboxUploaderMobileComponent } from './dropbox-uploader-mobile.component';
import { SmashHeaderModule } from '@app/shared/modules/smash-header/smash-header.module';

@NgModule({
  declarations: [
    DropboxUploaderMobileComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DropboxLandingMobileModule,
    DropboxPrepareMobileModule,
    DropboxSendMobileModule,
    SmashHeaderModule,
  ],
  exports: [
    DropboxUploaderMobileComponent,
  ]
})
export class DropboxUploaderMobileModule { }
